export function checkPassword(password: string): boolean {
  const re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
  return re.test(password);
}

export function checkIfHas8Letters(password: string): boolean {
  const re = /^.{8,}$/;
  return re.test(password);
}

export function checkIfHasUppercase(password: string): boolean {
  const re = /[A-Z]/;
  return re.test(password);
}

export function checkIfHasLowercase(password: string): boolean {
  const re = /[a-z]/;
  return re.test(password);
}

export function checkIfHasNumber(password: string): boolean {
  const re = /[1-9]/;
  return re.test(password);
}

export function checkIfHasSpecial(password: string): boolean {
  const re = /[!@#$%^&*]/;
  return re.test(password);
}